import React from 'react';
import { Dialog, DialogPanel } from '@headlessui/react';
import { Bars3Icon, XMarkIcon } from '@heroicons/react/24/outline';
import { navigation } from '../config/navigation';

const phoneNumber = '(817) 524-8117';

export const NavigationHeader = () => {

    const [mobileMenuOpen, setMobileMenuOpen] = React.useState(false);

    return (
        <React.Fragment>
            <header className='inset-x-0 fixed top-0 right-0 left-0 z-50 bg-gray-800 text-white'>
                <nav aria-label='Global' className='flex items-center justify-between p-4 sm:px-6 lg:px-8'>
                    <div className='flex lg:flex-1'>
                        <a href="https://overlandpark-it.com" className='-m-1.5 p-1.5'>
                            <span className='font-bold'>Overland Park IT</span>
                            {/* <img alt="Company Logo" src='https://tailwindui.com/img/logos/mark.svg?color=indigo&shade=600' className='h-8 w-auto' /> */}
                        </a>
                    </div>
                    <div className='flex lg:hidden'>
                        <button type='button' onClick={() => setMobileMenuOpen(true)} className='-m-2.5 inline-flex items-center justify-center rounded-md p-2.5 text-white'>
                            <span className='sr-only'>Open Main Menu</span>
                            <Bars3Icon aria-hidden="true" className='h-6 w-6' />
                        </button>
                    </div>
                    <div className='hidden lg:flex lg:gap-x-12'>
                        {navigation.map((item) => (
                            <a key={item.name} href={item.href} className='font-semibold leading-6'>
                                {item.name}
                            </a>
                        ))}
                    </div>
                    <div className='hidden lg:flex lg:flex-1 lg:justify-end'>
                        <a href='tel:817-524-8117' className='font-bold leading-6 inline-flex items-center'>
                            Call {phoneNumber} 
                        </a>
                    </div>
                </nav>
                <Dialog open={mobileMenuOpen} onClose={() => setMobileMenuOpen(false)} className="lg:hidden">
                    <div className='fixed inset-0 z-50' />
                    <DialogPanel className='fixed inset-y-0 right-0 z-50 w-full overflow-y-auto sm:max-w-sm sm:ring-gray-900/10 bg-white'>
                            <div className='flex items-center justify-between p-6' onClick={() => setMobileMenuOpen(false)}>
                                <a href="#" className='-m-1.5 p-1.5'>
                                    <span className='text-gray-900 font-bold'>OP-IT</span>
                                    {/* <img alt="Company Logo" src='https://tailwindui.com/img/logos/mark.svg?color=indigo&shade=600' className='h-8 w-auto' /> */}
                                </a>
                                <button type='button' className='-m-2.5 rounded-md p-2.5 text-gray-700'>
                                    <span className='sr-only'>Close Menu</span>
                                    <XMarkIcon aria-hidden="true" className='h-6 w-6' />
                                </button>
                            </div>
                            <div className='flow-root p-6'>
                                <div className='-my-6 divide-y divide-gray-500/30'>
                                    <div className='space-y-2 py-6'>
                                        {navigation.map((item) => (
                                            <div key={item.name} onClick={() => setMobileMenuOpen(false)}>
                                            <a href={item.href} className='-mx-3 block rounded-lg px-3 py-2 text-base font-semibold leading-7 text-gray-900 hover:bg-gray-50'>
                                                {item.name}
                                            </a>
                                            </div>
                                        ))}
                                    </div>
                                    <div className='py-6' onClick={() => setMobileMenuOpen(false)}>
                                        <a href='tel:817-524-8117' className='rounded-md bg-indigo-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600'>
                                        Call {phoneNumber}
                                        </a>
                                    </div>
                                </div>
                            </div>
                    </DialogPanel>
                </Dialog>
            </header>
        </React.Fragment>
    );
}